/*
  # Custom dropdown list

  Most of the functionality for this component exists in the accordion
  and radioSelectionText controllers. This controller only closes
  the accordion when the selection has changed.
*/

import { assignController, getControllers, controllersAvailable } from '../api/element-manipulation'

assignController('customDropdownList', (element) => {
  controllersAvailable( () => {
    const {accordion, radioSelectionText} = getControllers(element)
    radioSelectionText.onSelected.push ( () => {
      accordion.close()
    })
  } )
})

